import api from "../../helpers/api";


export const checkCustomerLimits = (body) => api.post(`customer/limits/check`, {...body})